export default "__VITE_ASSET__pUAAUGka__"